module.exports = __webpack_public_path__ + "img/proxy6.cc1c0407.png";